<template>
  <!-- <el-select size="mini" v-model="period" placeholder="账期">
    <el-option
      v-for="item in cities"
      :key="item.id"
      :label="item.period"
      :value="item.period"
    >
      <span style="float: left">{{ item.period }}</span>
      <span v-if="item.status == '4'" style="float: right;color: green;font-size: 14px;">已结账</span>
      <span v-else style="float: right;color: var(--el-text-color-secondary);font-size: 14px;">未结账</span>
    </el-option>
  </el-select> -->

  <el-select size="mini" @change="changeTime" v-model="period" placeholder="账期">
    <el-option-group
      v-for="group in list"
      :key="group.label"
      :label="group.label"
    >
      <el-option
        v-for="item in group.options"
        :key="item.id"
        :label="item.name"
        :value="item.period"
      >
      <span style="float: left">{{ item.name }}</span>
      <span v-if="item.settleStatus == '4'" style="float: right;color: green;font-size: 14px;">已结账</span>
      <span v-else-if="item.settleStatus" style="float: right;color: var(--el-text-color-secondary);font-size: 14px;">未结账</span>

      </el-option>
    </el-option-group>
  </el-select>


</template>
<script>
// <qzf-period @success="xxxx" v-model:period="period"></qzf-period>    重置后调用更新 this.$store.dispatch('commons/InitPeriod',"")


export default {
  name: 'period',
  props: {
    period: '',
  },
  computed: {
    list(){
      return this.$store.getters['commons/periods']
    }
  },
  data() {
    return {
     
    }
  },
  created () {
    
  },
  methods: {
    changeTime(){
      //历史数据
      var old = false
      if(this.list.length == 2){
        this.list[1].options.map(v=>{
          if(this.period == v.period){
            old = true
          }
        })
      }
      this.$emit('update:period', this.period)
      let data = {
        "old": old,
        "period": this.period
      }
      this.$emit("success", data)
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
